<template>
  <div>
    <v-row
      v-if="!outboundResponse"
      class="mt-6"
    >
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <v-card>
          <v-card-text>
            <h2 class="margin: 0 0 ;">
              Outbound Customer
            </h2>
            <v-container fluid>
              <v-row v-if="errorMessage">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-alert
                    type="warning"
                    dense
                    text
                  >
                    {{ errorMessage }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                >
                  <v-select
                    id="api_key"
                    v-model="outboundCampaignSelected"
                    :items="outboundCampaigns"
                    label="Outbound Campaign Name"
                    outlined
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                >
                  <v-text-field
                    id="ip_address"
                    v-model="customerName"
                    label="Customer Name"
                    outlined
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                >
                  <v-text-field
                    id="expired_at"
                    v-model="expiredAt"
                    label="Expired At"
                    type="date"
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                >
                  <v-text-field
                    id="expired_at"
                    v-model="ineligibleAt"
                    label="Ineligible At"
                    type="date"
                    outlined
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                >
                  <v-text-field
                    id="expired_at"
                    v-model="controlGroup"
                    label="Control Group"
                    type="number"
                    min="0"
                    max="9"
                    step="1"
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="9"
                  sm="6"
                >
                  <div ref="vjsoneditor" />
                </v-col>
              </v-row>
              <v-row class="pa-3">
                <v-col align="end">
                  <v-btn
                    class="mb-4 mr-2"
                    @click="cancelCreate()"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="blue darken-1 mb-4"
                    dark
                    :loading="creating"
                    @click="createOutboundCustomer()"
                  >
                    Create Outbound Customer
                  </v-btn>
                </v-col>
              </v-row>

              <v-row class="pa-3">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <h3>You may need this info!</h3>
                  <small>Click to open...</small>
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                >
                  <div
                    class="cursor-pointer"
                    @click="showCustomerData = !showCustomerData"
                  >
                    <b>Customer</b>
                  </div>
                  <vue-json-pretty
                    v-if="showCustomerData"
                    :data="apiResponse.customer"
                    :show-line="false"
                    :show-double-quotes="false"
                    virtual
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                >
                  <div
                    class="cursor-pointer"
                    @click="showLoanData = !showLoanData"
                  >
                    <b>Loan</b>
                  </div>
                  <vue-json-pretty
                    v-if="showLoanData"
                    :data="apiResponse.loan"
                    :show-line="false"
                    :show-double-quotes="false"
                    virtual
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                >
                  <div
                    class="cursor-pointer"
                    @click="showOutboundCampaignsData = !showOutboundCampaignsData"
                  >
                    <b>Outbound Campaigns</b>
                  </div>
                  <vue-json-pretty
                    v-if="showOutboundCampaignsData"
                    :data="apiResponse.outbound_campaigns"
                    :show-line="false"
                    :show-double-quotes="false"
                    virtual
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                >
                  <div
                    class="cursor-pointer"
                    @click="showCustomerLoginData = !showCustomerLoginData"
                  >
                    <b>Customer Login</b>
                  </div>
                  <vue-json-pretty
                    v-if="showCustomerLoginData"
                    :data="apiResponse.customer_login"
                    :show-line="false"
                    :show-double-quotes="false"
                    virtual
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="outboundResponse">
      <v-col
        cols="12"
        sm="12"
        md="12"
      >
        <vue-json-pretty
          :data="outboundResponse"
          :show-line="false"
          :show-double-quotes="false"
          virtual
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.min.css';
import VueJsonPretty from 'vue-json-pretty';

export default {
  name: 'CreateOutboundCustomers',
  components: { VueJsonPretty },
  props: {
    apiResponse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      outboundCampaigns: [],
      outboundCampaignSelected: null,
      customer: null,
      data: {},
      expiredAt: null,
      ineligibleAt: null,
      controlGroup: 1,
      customerName: '',
      json: '',
      jsonErrors: [],
      editor: null,
      errorMessage: '',
      creating: false,
      showCustomerData: false,
      showLoanData: false,
      showOutboundCampaignsData: false,
      showCustomerLoginData: false,
      outboundResponse: null,
    };
  },

  computed: {
    fullName() {
      return `${this.customer.firstname} ${this.customer.lastname}`;
    },
  },

  watch: {
    outboundCampaignSelected(newValue) {
      const campaignSelected = this.outboundCampaigns.find((campaign) => campaign.id === newValue);

      const jsonTemplate = campaignSelected.data_template?.template ?? '';

      this.editor.set(jsonTemplate ? JSON.parse(jsonTemplate) : '');
      this.errorMessage = '';
    },

    controlGroup(newValue) {
      if (newValue) {
        this.errorMessage = '';
      }
    },

    expiredAt(newValue) {
      if (newValue) {
        this.errorMessage = '';
      }
    },

    ineligibleAt(newValue) {
      if (newValue) {
        this.errorMessage = '';
      }
    },
  },

  mounted() {
    if (Object.keys(this.apiResponse).length) {
      this.outboundCampaigns = this.apiResponse.outbound_campaigns;
      this.customer = this.apiResponse.customer;
      this.customerName = this.fullName;

      // Creating a new Date object.
      const futureDate = new Date();

      // Set the month for the futureDate to one month in the future.
      futureDate.setMonth(futureDate.getMonth() + 1);

      // Initialize expireAt and ineligibleAt to one month in the future.
      this.expiredAt = this.formatDate(futureDate);
      this.ineligibleAt = this.formatDate(futureDate);
    }

    const self = this;

    const container = this.$refs.vjsoneditor;
    const options = {
      mode: 'code',
      onChange: this.jsonChange,
      onValidationError(errors) {
        self.jsonErrors = errors;
        return false;
      },
    };

    this.editor = new JSONEditor(container, options);
    this.editor.aceEditor.setOptions({
      useWorker: false,
    });

    this.editor.set(this.json);
    // Get Json
    // const updatedJson = this.editor.get();
  },

  methods: {
    validateDate(date) {
      if (!date) {
        return false;
      }

      const selectedDate = new Date(date);
      const currentDate = new Date();
      // Remove time part from the date object for a precise comparison
      selectedDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      if (Number.isNaN(selectedDate)) {
        return false;
      }

      return selectedDate > currentDate;
    },

    createOutboundCustomer() {
      if (!this.outboundCampaignSelected) {
        this.errorMessage = 'Outbound campaign is required!';
      }

      if (!this.customer) {
        this.errorMessage = 'Error getting this customer, please try again!';
      }

      if (!this.validateDate(this.expiredAt)) {
        this.errorMessage = 'Invalid expired at date!';
      }

      if (!this.validateDate(this.ineligibleAt)) {
        this.errorMessage = 'Invalid ineligible at date!';
      }

      if (!this.controlGroup || this.controlGroup < 0) {
        this.errorMessage = 'Invalid control group';
      }

      if (this.jsonErrors.length) {
        this.errorMessage = 'Invalid json, please fix it and try again!';
      }

      if (!this.errorMessage) {
        this.creating = true;
        this.$axios
          .post('api/v1/support/make-test-outbound-customer/outbound-customer', {
            outboundCampaign: this.outboundCampaignSelected,
            customer: this.customer.id,
            controlGroup: this.controlGroup,
            expiredAt: this.expiredAt,
            ineligibleAt: this.ineligibleAt,
            data: this.editor.get(),
          })
          .then((res) => {
            this.outboundResponse = res.data;
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              this.apiResponse = error.response.data;
              this.errorMessage = 'Something went wrong, please fix the form!';
            } else {
              this.setNotification({
                message: 'There was an error processing the lead, please try again',
                color: 'red',
              });
            }
          })
          .then(() => {
            // this.emit() = true;
            this.creating = false;
          });
      }
    },

    cancelCreate() {
      this.outboundCampaigns = [];
      this.outboundCampaignSelected = null;
      this.customer = null;
      this.data = {};
      this.expiredAt = null;
      this.ineligibleAt = null;
      this.controlGroup = 1;
      this.customerName = '';
      this.json = '';
      this.editor = null;
      this.jsonError = '';

      this.$emit('closeOutbound');
    },
    formatDate(date) {
      const d = new Date(date);
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = `${d.getFullYear()}`;

      if (month.length < 2) {
        month = `0${month}`;
      }
      if (day.length < 2) {
        day = `0${day}`;
      }

      return [year, month, day].join('-');
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
